import apiClient from "services/ApiClient";
import { NudgeTemplate, Nudge, NudgePreference } from "./types";

// Nudge Templates
export async function getNudgeTemplates() {
  return apiClient.get<NudgeTemplate[]>("/api/nudge-templates");
}

export async function getNudgeTemplate(id: string) {
  return apiClient.get<NudgeTemplate>(`/api/nudge-templates/${id}`);
}

export async function createNudgeTemplate(data: Partial<NudgeTemplate>) {
  return apiClient.post<NudgeTemplate>("/api/nudge-templates", data);
}

export async function updateNudgeTemplate(id: string, data: Partial<NudgeTemplate>) {
  return apiClient.put<NudgeTemplate>(`/api/nudge-templates/${id}`, data);
}

export async function deleteNudgeTemplate(id: string) {
  await apiClient.delete(`/api/nudge-templates/${id}`);
}

// Nudges
export async function getNudges() {
  return apiClient.get<Nudge[]>("/api/nudges");
}

export async function getNudge(id: string) {
  return apiClient.get<Nudge>(`/api/nudges/${id}`);
}

export async function dismissNudge(id: string) {
  return apiClient.post<Nudge>(`/api/nudges/${id}/dismiss`);
}

export async function actUponNudge(id: string) {
  return apiClient.post<Nudge>(`/api/nudges/${id}/act-upon`);
}

// Nudge Preferences
export async function getNudgePreferences() {
  return apiClient.get<NudgePreference[]>("/api/nudge-preferences");
}

export async function updateNudgePreference(id: string, data: Partial<NudgePreference>) {
  return apiClient.put<NudgePreference>(`/api/nudge-preferences/${id}`, data);
}

export async function batchUpdateNudgePreferences(ids: string[], data: Partial<NudgePreference>) {
  return apiClient.patch("/api/nudge-preferences/batch-update", {
    ids,
    ...data,
  });
}
